import loadable from '@loadable/component';


export default loadable(() => import(/* webpackChunkName: "filters" */ 'components/ListingFilters/Filters'));
